export enum ButtonType {
  solidColorBrush = 'SolidColorBrush',
  linearGradientBrush = 'LinearGradientBrush'
}
